module.exports = __webpack_public_path__ + "img/laptop.png?dcbe10f333aa122281b43b9376faca5a";